import React, { useState, useEffect } from 'react';
import { loadMetaObjectDefinitions, loadMetaObjects, loadMetaObject, saveMetaObjects, resetErrors } from '../../modules/metaObjects'
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Link from '@mui/material/Link';
import ItemsList from '../../components/ItemsList'
import ItemsListSkeleton from '../../components/ItemsListSkeleton'
import LoadingIndicator from '../../components/LoadingIndicator';
import EmptyView from '../../components/EmptyView';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import OptionsMenu from '../../components/OptionsMenu';
import NewFlexItemList from '../../components/NewFlexItemList';
import cloneDeep from 'lodash/cloneDeep';
import Collapse from '@mui/material/Collapse';
import { Alert, AlertTitle } from '@mui/material';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import ExportImportDialogs from '../../components/ExportImportDialogs';
import { _clearUnchangedFields, _getValidationPropsFromValidations } from '../../helper';
import API from '../../api/api';
import { FilterOptionsSelect, FilterOptionsQuery, FilterOptionsSort } from '../../components/ItemsListFilterOptions';
import UpdateAppPermissionsDialog from '../../components/UpdateAppPermissionsDialog';
import { withSnackbar } from '../../utils/withSnackbar';
import SolutionsArticleLink from '../../components/SolutionsArticleLink';


class MetaObjects extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      metaobjects: [],
      errorLockCollapse: false,
      initialItem: null,
      lastDefinitionsCursor: null,
      lastMetaobjectsCursor: null
    }
  }

  componentDidMount() {
    this.props.loadMetaObjectDefinitions({}, true);

    // Deeplinking
    let uriParts = this.props.location.pathname.split('/');
    let id = uriParts[3] ? uriParts[3] : uriParts[2];
    if(id) {
      this.props.loadMetaObject(id, this.props.editLanguage, this.handleMetaObjectExpanded);
      this.setState({
        initialItem: id
      })

    } else {
      this.props.loadMetaObjects({}, true);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.editLanguage !== prevProps.editLanguage) {
      // Reset cursor tracking when language changes
      this.setState({
        lastDefinitionsCursor: null,
        lastMetaobjectsCursor: null
      });

      this.props.loadMetaObjectDefinitions({}, true);

      // Deeplinking
      let uriParts = this.props.location.pathname.split('/');
      let id = uriParts[3] ? uriParts[3] : uriParts[2];
      if(id) {
        this.props.loadMetaObjects({}, true, () => {
          this.props.loadMetaObject(id, this.props.editLanguage, this.handleMetaObjectExpanded);
          this.setState({
            initialItem: id
          })
        });
      } else {
        this.props.loadMetaObjects({}, true);
      }
      return
    }
  }

  componentWillReceiveProps(newProps) {
    const { t } = this.props;

    // The rows are rebuilt only when a load ends. The list remounts on the switch (its key), and
    // one that mounts on the old language's rows takes their targets over the new load's, in
    // place - so the rows go before that render, not after it in componentDidUpdate.
    if(newProps.editLanguage !== this.props.editLanguage) {
      this.setState({ metaobjects: [] });
    }

    if((this.props.metaObjects.load_metaobject_pending === true && newProps.metaObjects.load_metaobject_pending === false) 
    || (this.props.metaObjects.save_metaobjects_pending === true && newProps.metaObjects.save_metaobjects_pending === false) 
    || (this.props.metaObjects.load_metaobjects_pending === true && newProps.metaObjects.load_metaobjects_pending === false)
    // the definitions carry the readable names for the row subtitles and may arrive after the list
    || (this.props.metaObjects.load_metaobject_definitions_pending === true && newProps.metaObjects.load_metaobject_definitions_pending === false)) {
      if(this.state.reloadingList) this.setState({ reloadingList: false });
      const newMetaobjects = [];
      const definitions = newProps.metaobject_definitions || [];
      const definitionName = (type) => type ? (definitions.find(d => d.type === type)?.name || type) : '';
      if(newProps.metaobjects && newProps.metaobjects.length > 0) {
        newProps.metaobjects.forEach(item => {
          let newFields = [];
          if(item.translations) {
            item.translations.forEach((field) => {
              newFields.push({
                multiline: field.type  === 'MULTI_LINE_TEXT_FIELD' ? true : false,
                rows: field.type  === 'MULTI_LINE_TEXT_FIELD' ? 5 : 1,
                id: field.key,
                type: 'text',
                label: field.key,
                source: field.source,
                target: field.target === null ? '' : field.target,
                error: field.error, 
                restore: field.restore,
                ..._getValidationPropsFromValidations(field.validations)
              })
            })            
          }
          // the admin's entry page lives under the definition type. Only the open entry has a menu to
          // show the link, and an open entry has been loaded on its own, which brings the definition
          const entryId = item.shopify_id.replace('gid://shopify/Metaobject/', '');
          const storeName = (this.props.shopUrl || '').replace('.myshopify.com', '');
          const definitionType = item.metaobject_definition?.type || null;
          newMetaobjects.push({
            type: 'metaobject',
            id: entryId,
            shopify_id: item.shopify_id,
            admin_url: (definitionType && storeName) ? `https://admin.shopify.com/store/${storeName}/content/metaobjects/entries/${definitionType}/${entryId}` : null,
            progress: !item.progress ? -1 : item.progress,
            synchronized: item.synchronized,
            title: item.display_name ? item.display_name : '',
            // the definition as the row's subtitle: its name where the definitions list knows it, else its key
            subtitle: definitionName(item.definition || item.metaobject_definition?.type),
            info: '',
            hasError: item.hasError,
            fields: newFields ? cloneDeep(newFields) : null
          })
        })       
        this.setState({metaobjects: newMetaobjects});
      }
    }
  }

  onExpand(id) {
    const row = this.state.metaobjects.find(x => x.id == id);
    // no row yet: the list opened its deep-linked entry right after a language switch emptied
    // the rows, and that switch loads the entry itself
    if(!row) return;
    if(row.synchronized !== true) {
      this.props.loadMetaObject(id, this.props.editLanguage, this.handleMetaObjectExpanded);
    }
  }

  onExpanded(id) {
    if (!this.notTranslatableSnackbarKey) {
      this.handleMetaObjectExpanded(this.props.metaobjects.find(x => x.shopify_id === 'gid://shopify/Metaobject/'+id));
    }
  }

  onCollapse = (id) => {
    if (this.notTranslatableSnackbarKey) {
      this.props.closeSnackbar(this.notTranslatableSnackbarKey);
      this.notTranslatableSnackbarKey = null;
    }
  }

  onSave = items => {
    const usedItems = [];
    items.forEach(item => {
      const newTranslations = [];
      item.fields.forEach((field, i) => {
        newTranslations.push({
          key: field.id,
          value: field.target || '',
        })
      })
      usedItems.push({
        resource_id: item.shopify_id,
        translations: newTranslations
      });
    })
    this.props.saveMetaObjects(this.props.editLanguage, usedItems, res => {

    })
  }

  onLoadMore = () => {
    // Prevent duplicate requests with the same cursor
    if(this.state.lastMetaobjectsCursor === this.props.metaObjects.cursor) {
      return;
    }
    this.setState({ lastMetaobjectsCursor: this.props.metaObjects.cursor });
    this.props.loadMetaObjects({
      cursor: this.props.metaObjects.cursor,
      ...Object.assign({}, this.filterObject)
    })
  }

  handleMetaObjectExpanded = (data) => {
    let res = data;
    if(!res.id) {
      if(res.shopify_id) {
        res.id = res.shopify_id.replace('gid://shopify/Metaobject/', '')
      } else {
        res.id = res.metaobject.id.replace('gid://shopify/Metaobject/', '')
      }
    }
    if(res?.metaobject_definition?.translatable === false) {
      const message = res.metaobject_definition.settings_link ? (
        <span>
          {this.props.t('pages.metaobjects.notTranslatable')}{' '}
          <Link
            href={res.metaobject_definition.settings_link}
            target="_blank"
            color="inherit"
            style={{ textDecoration: 'underline' }}
            underline="hover">
            {this.props.t('pages.metaobjects.enableTranslations')}
          </Link>
          {' | '}
          <Link
            component="button"
            color="inherit"
            style={{ textDecoration: 'underline', verticalAlign: 'baseline' }}
            onClick={() => {
              this.props.closeSnackbar(this.notTranslatableSnackbarKey);
              this.props.loadMetaObject(res.id, this.props.editLanguage, this.handleMetaObjectExpanded);
            }}
            underline="hover">
            Reload
          </Link>
        </span>
      ) : this.props.t('pages.metaobjects.notTranslatable');

        const snackbarKey = this.props.enqueueSnackbar(message, {
          variant: 'info',
          persist: true,
          preventDuplicate: true,
          action: (key) => (
            <IconButton
              size="small"
              color="inherit"
              onClick={() => this.props.closeSnackbar(key)}
              style={{ position: 'absolute', top: 0, right: 0 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )
        });
        this.notTranslatableSnackbarKey = snackbarKey;        
    }
  }

  // a filter, definition or sort change reloads the list from the first page. The store empties
  // its list at once, but the page keeps the old rows on screen until the response arrives, so a
  // flag carries the wait to the overlay - a slow search otherwise looked like nothing happened
  reloadList = (filterObject) => {
    this.setState({ lastMetaobjectsCursor: null, reloadingList: true });
    this.filterObject = filterObject;
    this.props.loadMetaObjects(filterObject, true);
  }

  render() {
    const { t } = this.props

    const FilterQueryModule = <FilterOptionsQuery
      // the box matches the metaobject's display name and id
      placeholderKey="itemsList.filterPlaceholderTitleId"
      initialItem={this.state.initialItem ? this.state.initialItem : null}
      onChange={this.reloadList}
      history={this.props.history}
    />
    const FilterDefinitionsModule = <FilterOptionsSelect
      options={this.props.metaobject_definitions}
      // closed it invites a choice; the empty entry in the menu names what no choice means
      placeholder={t('pages.metaobjects.selectDefinition')}
      emptyOptionLabel={t('pages.metaobjects.allDefinitions')}
      onChange={this.reloadList}
      enablePagination={true}
      onLoadMore={this.props.metaObjects.definitions_cursor &&
                  this.state.lastDefinitionsCursor !== this.props.metaObjects.definitions_cursor ? () => {
        this.setState({ lastDefinitionsCursor: this.props.metaObjects.definitions_cursor });
        this.props.loadMetaObjectDefinitions({
          cursor: this.props.metaObjects.definitions_cursor
        });
      } : null}
      history={this.props.history}
    />
    const FilterSortModule = <FilterOptionsSort
      initialValue={'updated_at'}
      options={[
        {type: 'id', name: this.props.t('pages.metaobjects.sort.id')},
        {type: 'type', name: this.props.t('pages.metaobjects.sort.type')},
        {type: 'updated_at', name: this.props.t('pages.metaobjects.sort.updatedAt')},
        {type: 'display_name', name: this.props.t('pages.metaobjects.sort.displayName')},
      ]}
      onChange={this.reloadList}
      history={this.props.history}
    />

    return (
      <React.Fragment>
        <Typography variant="h4" gutterBottom component="h2">
          {t('pages.metaobjects.title')}

          <SolutionsArticleLink
            article="metaobjectsIdentify"
            subject={t('pages.metaobjects.title')}
            placement="heading"
          />
          {/*<OptionsMenu
          onImport={this.onImport}
          onExport={this.onExport}
          shopPlan={this.props.shopPlan}
        />*/}
        </Typography>

        <Divider className="divider-white" />

        {this.props.metaObjects.permissionUpdateNeeded && (
          <UpdateAppPermissionsDialog shop={this.props.shop} />
        )}

        <ItemsList
          // remount on a language switch: a mounted list carries the targets of rows it already
          // held over the freshly loaded ones, so the old language stayed under the new one
          key={`metaobjects-itemslist-${this.props.editLanguage}`}
          type="metaobjects"
          useLazyloading
          loadMoreButton={this.props.metaObjects.cursor}
          onLoadMore={this.onLoadMore}
          filterModules={[
            FilterQueryModule,
            this.state.metaobjects.length === 1 &&
            window.location.pathname.split('/').length === 3
              ? null
              : FilterDefinitionsModule,
            this.state.metaobjects.length === 1 &&
            window.location.pathname.split('/').length === 3
              ? null
              : FilterSortModule
          ]}
          //allowGroupFiltering={true}

          pagination={false}
          paginate={false}
          onExpand={id => {
            this.onExpand(id)
          }}
          onExpanded={id => {
            this.onExpanded(id)
          }}
          onCollapse={this.onCollapse}
          isPending={
            this.props.metaObjects.load_metaobjects_pending ||
            this.props.metaObjects.load_metaobject_pending ||
            this.props.metaObjects.save_metaobjects_pending
          }
          isSubfieldsPending={false}
          isSubfieldsRemoving={false}
          isSaving={this.props.metaObjects.save_metaobjects_pending}
          onSave={this.onSave}
          //onResaveAll={this.onResaveAll}
          data={this.state.metaobjects}
          onExpandCollapsableFields={this.onExpandCollapsableFields}
          allowAutoTranslation={true}
          error={this.props.metaObjects.error}
          errorLockCollapse={this.state.errorLockCollapse}
          saveErrors={this.props.metaObjects.saveErrors}
          emptyMessage={
            this.props.metaObjects.load_metaobjects_pending === false &&
            this.props.metaobjects.length === 0 ? (
              <EmptyView
                title={t('pages.metaobjects.noContent')}
                bottom={
                  <Button
                    href={`https://${this.props.shopUrl}/admin/content/entries`}
                    variant="contained"
                    color="primary">
                    {t('system.createOneHere')}
                  </Button>
                }
              />
            ) : (
              <ItemsListSkeleton rows={5} />
            )
          }
        />
        <LoadingIndicator
          //transparent
          pending={
            (this.props.metaObjects.load_metaobjects_pending &&
              (this.state.metaobjects.length === 0 || this.state.reloadingList)) ||
            this.props.metaObjects.load_metaobject_pending ||
            this.props.metaObjects.save_metaobjects_pending ||
            this.props.metaObjects.load_metaobject_definitions_pending
          }
          loadingType={
            this.props.metaObjects.save_metaobjects_pending
              ? 'saving'
              : 'loading'
          }
          progress={
            this.props.metaObjects.progress < 0
              ? 0
              : this.props.metaObjects.progress
          }
          error={this.props.metaObjects.error}
          onErrorCancel={this.props.resetErrors}
          onErrorRetry={() => {
            this.setState({ errorLockCollapse: true }, () => {
              this.setState({ errorLockCollapse: false })
            })
          }}
        />
      </React.Fragment>
    )
  }
}


const mapStateToProps = ({ metaObjects, shop }) => ({
  metaObjects: metaObjects,
  metaobjects: metaObjects.metaobjects,
  metaobject_definitions: metaObjects.metaobject_definitions,
  pageInfo: metaObjects.page_info,
  editLanguage: shop.shop.edit_language,
  shopUrl: shop.shop.url,
  shopPlan: shop.shop.charge.name,
  shop: shop.shop
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadMetaObjectDefinitions,
      loadMetaObjects,
      loadMetaObject,
      saveMetaObjects,
      resetErrors
    },
    dispatch
  )

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withSnackbar(MetaObjects))))